import { Box } from "@mui/material";
import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { adminCatalogItem } from "../../../../types";
import { useStyles } from "./styles";

type Props = {
  rows: adminCatalogItem[] | undefined;
  loading?: boolean;
};

const CatalogItemsTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "technicalNote",
        label: t("CATALOGS.ITEMS.TABLE.TECHNICAL_NOTE"),
        minWidth: 160,
        align: "right",
        format: (row: adminCatalogItem) => t(row.technicalNote),
      },
      {
        id: "weightPerMeter",
        label: t("CATALOGS.ITEMS.TABLE.WEIGHT_PER_METER"),
        minWidth: 120,
        align: "right",
      },
      {
        id: "profileHeight",
        label: t("CATALOGS.ITEMS.TABLE.PROFILE_HEIGHT"),
        minWidth: 120,
        align: "right",
      },
      {
        id: "itemName",
        label: t("CATALOGS.ITEMS.TABLE.ITEM_NAME"),
        minWidth: 160,
        align: "right",
        format: (row: adminCatalogItem) => t(row.itemName),
      },
      {
        id: "itemCode",
        label: t("CATALOGS.ITEMS.TABLE.ITEM_CODE"),
        minWidth: 120,
        align: "right",
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root}>
      <DataTable
        rows={rows || []}
        columns={columns}
        loading={loading}
        serialEnabled={false}
      />
    </div>
  );
};

export default CatalogItemsTable;
